// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import snakeCase from 'lodash/snakeCase';
import { useTranslation } from 'react-i18next';
import { RateWeight } from 'types/dashboard';
import { convertWeight, normalizeNumber } from 'util/commons';
import { UnitType } from 'util/constants/dashboard';
import styles from './ProcessInfoBoxOrganism.module.scss';
import { mergeClasses } from 'util/commons';
import { IconInfo } from 'components/atoms/icons/IconInfo';
import Popover from 'components/atoms/Popover';

const ProcessInfoBoxOrganism = ({
  unitType,
  rateWeight,
  chainType,
}: {
  unitType: UnitType;
  rateWeight?: RateWeight[];
  chainType?: 'middle';
}) => {
  const { t } = useTranslation();

  const getName = (item: RateWeight) => {
    if (item.stageIndex % 1 !== 0) {
      return (
        <>
          <p>{t('purchase_page.dashboard.process_generated')}</p>
          <p>({t(`purchase_page.dashboard.${snakeCase(item.stageName)}`)})</p>
        </>
      );
    }

    return t(`purchase_page.dashboard.${snakeCase(item.stageName)}`);
  };

  const getDetail = (item: RateWeight) => {
    if (item.stageIndex % 1 !== 0) {
      return t(
        `purchase_page.dashboard.score_board_detail.middle_chain.${snakeCase(
          item.stageName
        )}`
      );
    }

    return t(
      `purchase_page.dashboard.score_board_detail.${snakeCase(item.stageName)}`
    );
  };

  return (
    <div
      className={mergeClasses(styles.processInfoBox, {
        [styles.processInfoBoxMiddleChain]: chainType === 'middle',
      })}
    >
      {rateWeight?.map((item, i) => {
        return (
          <div className={styles.generalItem} key={i}>
            <div
              className={styles.generalItemWrapper}
              style={{
                visibility: item.hidden ? 'hidden' : 'visible',
              }}
            >
              {!item.hidden && (
                <>
                  <Popover
                    content={getDetail(item)}
                    positions="top"
                    popUpStyle={{
                      fontSize: '14px',
                      maxWidth: '600px',
                      textAlign: 'center',
                      whiteSpace: 'pre-line',
                      lineHeight: 'normal',
                    }}
                  >
                    <span className={styles.infoDetail}>
                      <IconInfo
                        width={18}
                        height={18}
                        fill="white"
                        stroke="white"
                      />
                    </span>
                  </Popover>

                  <p className={styles.label}>{getName(item)}</p>
                  <div className={styles.quantityUnit}>
                    <p className={styles.quantity}>
                      {item.weight
                        ? normalizeNumber({
                            value: convertWeight(unitType, Number(item.weight)),
                          })
                        : 0}
                    </p>
                    <p className={styles.unit}>{unitType}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProcessInfoBoxOrganism;
